"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const writeFunctionOutputToRegistry_1 = __importDefault(require("../../shared/writeFunctionOutputToRegistry"));
const Runtime_1 = require("../../types/Runtime");
const buildFunctionEvaluator_1 = __importDefault(require("../buildFunctionEvaluator"));
const legacyForEachBuilder_1 = __importDefault(require("./legacyForEachBuilder"));
/* eslint-disable no-await-in-loop */
const forEachBuilder = (functionsDefinitions) => async ({ store, functionId, callbacks, executeProcesses, lastFunctionsOutputs, entryVars: { collection, sync, }, controlCallerId, callbacksDefinition, processor, eventOutputs, }) => {
    let mode = 'default';
    if (sync === 'sync' || sync === 'async') {
        mode = sync;
    }
    if (mode === 'default') {
        await (0, legacyForEachBuilder_1.default)()({
            store,
            functionId,
            callbacks,
            executeProcesses,
            lastFunctionsOutputs,
            entryVars: {
                collection,
                sync,
            },
            controlCallerId,
            callbacksDefinition,
            processor,
            eventOutputs,
        });
        return;
    }
    const executeFunctions = (result) => (0, buildFunctionEvaluator_1.default)({
        store,
        processor,
        functionEntryVar: {
            source: Runtime_1.ENTRY_VAR_SOURCE.COMPUTE_FUNCTION,
            process: callbacksDefinition === null || callbacksDefinition === void 0 ? void 0 : callbacksDefinition.onIteration,
        },
        controlCallerId,
        lastFunctionsOutputs: (0, writeFunctionOutputToRegistry_1.default)(lastFunctionsOutputs, functionId, result),
        functionsDefinitions,
        eventOutputs,
    });
    let results;
    const onDone = () => {
        executeProcesses(functionId, callbacks.onDone, results);
    };
    if (Array.isArray(collection)) {
        results = [];
        if (mode === 'async') {
            results = await Promise.all(collection
                .map((item, i) => executeFunctions({ key: i, item, index: i })));
        }
        else {
            for (let i = 0; i < collection.length; i += 1) {
                results.push(await executeFunctions({ key: i, item: collection[i], index: i }));
            }
        }
        onDone();
    }
    else if (typeof collection === 'object') {
        const entries = Object.entries(collection || {});
        if (mode === 'async') {
            results = (await Promise.all(entries.map(async ([key, item], i) => [
                key,
                await executeFunctions({ key, item, index: i }),
            ]))).reduce((accum, [key, value]) => (Object.assign(Object.assign({}, accum), { [key]: value })), {});
        }
        else {
            results = {};
            for (let i = 0; i < entries.length; i += 1) {
                const [key, item] = entries[i];
                results[key] = await executeFunctions({ key, item, index: i });
            }
        }
        onDone();
    }
    else {
        await executeProcesses(functionId, callbacks.onNonIterableCollection, {
            key: 0,
            item: collection,
        });
    }
};
exports.default = forEachBuilder;
